import React, { useEffect, useRef } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { ArrowDownIcon } from "@/components/Icons";
import { TABS, isTabActive } from "./tabs";

export default function DesktopTabs() {
  const { pathname } = useLocation();
  const activeTabRef = useRef(null);

  useEffect(() => {
    if (activeTabRef.current) {
      activeTabRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [pathname]);

  return (
    <Box
      display={{ base: "none", md: "block" }}
      bg="white"
      w="full"
      borderBottomWidth="1px"
      borderBottomColor="textBlack.600"
    >
      <Flex
        gap={6}
        flexWrap="nowrap"
        overflowX="visible"
        overflowY="visible"
        maxW="8xl"
        mx="auto"
        // px={100}
        pt={4}
        pb={0}
        css={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          scrollSnapType: "x proximity",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {TABS.map(({ label, to, chevron }) => {
          const active = isTabActive(pathname, to);
          return (
            <Box
              key={to}
              as={Link}
              to={to}
              ref={active ? activeTabRef : null}
              flexShrink={0}
              className="focus-bordered"
              borderRadius="2px"
              css={{ scrollSnapAlign: "start" }}
            >
              <Flex direction="column" align="flex-start" gap="8px">
                <Flex align="center" gap="4px">
                  <Text
                    textStyle="body.regular"
                    color="textBlack.800"
                    whiteSpace="nowrap"
                    fontWeight={active ? 600 : 400}
                  >
                    {label}
                  </Text>
                  {chevron ? <ArrowDownIcon w="10px" h="5px" color="textBlack.800" /> : null}
                </Flex>
                <Box h="5px" w="full" bg={active ? "primary.800" : "transparent"} />
              </Flex>
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
}
